import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { ILedgerDetail, ILedgerSearchFields, ledgerService } from './ledgerService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { ModoulTypeList } from '@/types/TcoDs'
import { convertRes2Blob } from '@/utils/exportFile'
import { fleetService } from '@/views/base/fleet/fleetService'

export const useLedgerModel = createModel(function () {
    const {
        user: { shopCode, createUser, userType, dealerName },
    } = useGlobalModel(({ user }) => [user])
    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<any[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<ILedgerDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<ILedgerDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
    const [SelectedId, setSelectedId] = useState('')
    //对账明细打开页面
    const [detailVisible, setDetailVisible] = useState(false)
    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    // 公司数据
    const [companyData, setCompanyData] = useState<any[]>([])

    //编辑弹窗
    const [editCarVisible, setEditCarVisible] = useState<any>({
        visible: false,
        value: {},
    })
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: ILedgerSearchFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            threeInspectionStatus: searchValue.threeInspectionStatus === '1' ? 'there.are.hidden.dangers' : '',
            createUserId: shopCode,
            // history:1,
            // fleet: userType === '管理员' ? createUser : undefined,
            // retrieveName: userType === '司机' || userType === '押运员' ? createUser : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            createUser: userType === '超级管理员' ? searchValue.createUser : createUser,
            dealerName: dealerName || undefined,
        }

        if (searchParams?.createUser && typeof searchParams.createUser === 'object' && searchParams.createUser.length > 0) {
            searchParams.createUser = searchParams.createUser.join(',') || ''
        }
        let { retData } = await ledgerService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        // setPgCfg(transPgToPagination({ total: records.length, size: 100, current: 1 }))

        // 对 records 中的 circulationLogList 按照指定顺序排序
        const sortedRecords = records.map((record: any) => {
            if (record.circulationLogList && Array.isArray(record.circulationLogList)) {
                // 定义排序顺序
                const order = ['出车前', '出车中', '收车后']

                // 创建一个新数组，确保包含所有指定顺序的元素
                const sortedList = order.map((phase) => {
                    // 在原始数据中查找对应阶段的元素
                    const item = record.circulationLogList.find((log: any) => log.faultDescription === phase)
                    // 如果找到了就使用该元素，否则用 {signMd5:''} 占位
                    return item || { faultDescription: phase, signMd5: '' }
                })

                return {
                    ...record,
                    circulationLogList: sortedList,
                }
            }
            return record
        })

        setDataSource(sortedRecords)
        // let { retData: totalList } = await ledgerService.getTotal(shopCode)
        // setTotalNum(totalList)
        setLoading(false)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ILedgerSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {}).then(() => {})
    }
    //导出
    const ledgerExport = async () => {
        let result = await ledgerService.export(selectedRowKeys[0])
        convertRes2Blob(result)
    }
    // 获取公司列表
    const fetchCompanyList = async () => {
        try {
            let data = {
                type: 'company',
                createUserId: shopCode,
            }
            let { retData } = await fleetService.page(data)
            setCompanyData(
                retData?.map((item: any) => ({
                    label: item.institutionName,
                    value: item.institutionName,
                })) || [],
            )
        } catch (error) {
            setCompanyData([])
        }
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        detailEditForm,
        detailAddForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        companyData,
        editCarVisible,
        /***method***/
        setEditCarVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setMode,
        setSelectedId,
        ledgerExport,
        fetchCompanyList,
    }
})
